import { createStyles, Theme } from '@material-ui/core';

import { styleFormIoComponent } from '#web-components/styles/form';
import { COMPONENT_CLASSES } from '../../constants';

export const SCROLLABLE_GRID_CLASS = 'formio-map_scrollable-grid';
export const OVERLAY_GRID = 'formio-map_overlay-grid';

export default (theme: Theme) => createStyles({
  '@global': {
    ...styleFormIoComponent(COMPONENT_CLASSES.map, theme),
    [`.${SCROLLABLE_GRID_CLASS}`]: {
      overflowX: 'scroll',
      '& td[ref] > *': {
        width: theme.spacing(25),
      },
    },
    [`.${OVERLAY_GRID}`]: {
      '& .row > *': {
        overflow: 'hidden',
        paddingLeft: theme.spacing(1),
        paddingRight: theme.spacing(1),
      },
    },
    '.leaflet-control-layers .leaflet-control-layers-list label': {
      display: 'block',
    },
  },
});
